// src/Dashboard/pages/user/Absences/constants/absenceConstants.js

export const INFO_TXT =
  "Pour un souci d’organisation, nous demandons aux parents de signaler les absences de plus d’un cours aux enseignants et au bureau. Merci de penser à remettre l’adhérent en actif dès son retour.";

export const ABSENCE_TYPES = ["Absent(e)", "Malade", "Blessé(e)"];

export const DEFAULT_USER_PHOTO = "/img/user_avatar.jpg";